import { Config } from '../core/config'
import { model } from "../core/model";
import AppEvent from './appEvent'

// ==================================================
// Extrae un parametro de la current url
// ==================================================   
const returnBack = function () { 
    var pagina = (model.Window.pagina);
    console.log('RETURN BACK',pagina); 
    if (pagina) redirect(pagina || Config.defaultRedirectUrl);
}

const redirect = function (url) {
    window.location = url;
}


const appendToUrl = (url, key, value) => {
    if ((url).indexOf('?') == -1) {
        url = url + '?';
    }
    else {
        url = url + '&';
    }
    url = url + key + '=' + value;
    return url;
}

const urlBuilder = (url) => {
    if (model.Window.canalVenta) {
        url = appendToUrl(url, 'cv', model.Window.canalVenta);
    }
    if (model.Window.contact) {
        url = appendToUrl(url, 'fc', model.Window.contact);
    }
    if (model.ProductCategory && model.ProductCategory!=null) {
        url = appendToUrl(url, 'productCategory', model.ProductCategory);
    }
    if (model.Window.pagina) {
        url = appendToUrl(url, 'callback', window.btoa(model.Window.pagina));
    }
       
    //temporal para mantener compatibilidad con wall anterior
    url = appendToUrl(url, 'ref', window.btoa(location.href));

    return url; 

}

const redirectToLoginWCombo = function (combo) {
    //redirecciona a login para que vuelva a una pagina de Compra /C/14/?algo... carrito
    let url = Config.urlRedirect + combo + '/';
    url = urlBuilder(url);
    let encode_url = window.btoa(url);
    console.log(AppEvent);
    AppEvent.sendEvent('REDIRECT', window.atob(encode_url));
    if (model.Embed.Mobile) {
        return;
    }
    encode_url = Config.dominioIngresar + encode_url;
    if (model.Embed.Article) {
        encode_url = appendToUrl(encode_url, 'article', true);
    }
    console.log('NAVIGATE->',url,encode_url);
    redirect(encode_url);
}

const redirectToCombo = function (combo) {
    //redirecciona a una pagina de Compra /C/14/?algo... carrito
    let url = Config.urlRedirect + combo + '/';
    url = urlBuilder(url);
    console.log('NAVIGATE->',url);
    redirect(url);
}

const redirectToLoginWAction = function (accion) {
    let url = Config.urlRedirectAccion + accion + '/';
    url = urlBuilder(url);
    let encode_url = window.btoa(url);
    AppEvent.sendEvent('REDIRECT', window.atob(encode_url));
    if (model.Embed.Mobile) {
        return;
    }
    encode_url = Config.dominioIngresar + encode_url;
    if (model.Embed.Article) {
        encode_url = appendToUrl(encode_url, 'article', true);
    }
    console.log('NAVIGATE->',url,encode_url);
    redirect(encode_url);
}

const redirectToLogin = function () {
    var encode_url = window.btoa(model.Window.location);
    AppEvent.sendEvent('REDIRECT', window.atob(encode_url));
    if (model.Embed.Mobile) {
      return;
    }
    if (model.Embed.Article) {
      encode_url = encode_url + '&article=' + true;
    }
    redirect(Config.dominioIngresar + encode_url);
  }

module.exports = {
    redirect,
    returnBack, 
    redirectToLoginWCombo,
    redirectToCombo,
    redirectToLoginWAction,
    redirectToLogin
};


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/helpers/url.js